<template>
  <b-row>
    <b-col sm="3">
      <b-card class="bg-info-fade height-card">
        <h4 class="mb-1 d-inline-block">
          <strong class="mr-1">Total</strong>
        </h4>
        <h2 class="mb-0">
          <strong>{{ total_ml }} ml</strong>
        </h2>
      </b-card>
    </b-col>
    <b-col sm="3">
      <b-card class="height-card bg-light-fade">
        <h4 class="mb-1 d-inline-block">
          <strong class="mr-1">Total</strong>
        </h4>
        <h2 class="mb-0">
          <strong>{{ total_m2 }} m2</strong>
        </h2>
      </b-card>
    </b-col>
    <b-col sm="3">
      <b-card class="height-card bg-success-fade">
        <h4 class="mb-1 d-inline-block">
          <strong class="mr-1">Total n/a</strong>
        </h4>
        <h2 class="mb-0">
          <strong>{{ total_no }}</strong>
        </h2>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BCard, BRow, BCol } from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BCard,
    BCol,
    BRow,
  },
  props: {
    user: {
      //   type: Number,
      default: 0,
    },
    client: {
      type: String,
      default: '',
    },
    day: {
      type: Number,
      default: 0,
    },
    project: {
      type: [Number, String],
      default: '',
    },
    status: {
      type: String,
      default: '',
    },
    dateIniProp: {},
    dateFinProp: {},
  },
  data() {
    return {
      type: 'line',
    }
  },
  watch: {
    user() {
      this.chargeData()
    },
    client() {
      this.chargeData()
    },
    project() {
      this.chargeData()
    },
    day() {
      this.chargeData()
    },
    status() {
      this.chargeData()
    },
    dateIniProp() {
      this.chargeData()
    },
    dateFinProp() {
      this.chargeData()
    },
  },
  computed: {
    ...mapGetters({
      currentClient: 'clients/getCurrentClient',
      stadistics: 'tasks/getStadisticsProduction',
    }),
    total_no() {
      console.log("sheila")
      if (this.stadistics) {
        console.log("sheila")
        console.log(this.stadistics)
        return this.stadistics.total_no ? this.stadistics.total_no : 0
      }
      return 0
    },
    total_ml() {
      if (this.stadistics) {
        return this.stadistics.total_ml ? this.stadistics.total_ml : 0
      }
      return 0
    },
    total_m2() {
      if (this.stadistics) {
        return this.stadistics.total_m2 ? this.stadistics.total_m2 : 0
      }
      return 0
    },
  },
  methods: {
    ...mapActions({
      getStadisticsProduction: 'tasks/getStadisticsProduction',
    }),
    chargeData() {
      this.getStadisticsProduction({
        user: this.user,
        client: this.client,
        project: this.project,
        status: this.status,
        date_ini: this.dateIniProp,
        date_fin: this.dateFinProp,
      })
    },
  },
  async created() {
    let client = this.currentClient ? this.currentClient.id : ''
    if (this.clientprop) {
      client = this.clientprop
    }
    await this.chargeData()
  },
}
</script>
<style lang="scss"></style>
